import type { DevicePairingStatus } from '@axilon-apps/domains-identity/state'

/** Statuses during which the web keeps polling and the QR stays on screen. */
export function isPairingInFlight(status: DevicePairingStatus): boolean {
  return status === 'pending' || status === 'claimed'
}

/**
 * Status to render, folding the local clock in: an in-flight pairing whose
 * `expiresAt` has passed is treated as expired without waiting for the next
 * poll. Terminal server statuses always win. An unparseable `expiresAt` never
 * expires locally (the server stays authoritative).
 */
export function effectivePairingStatus(
  serverStatus: DevicePairingStatus,
  expiresAt: string,
  now: number
): DevicePairingStatus {
  if (!isPairingInFlight(serverStatus)) return serverStatus
  const expiry = Date.parse(expiresAt)
  if (Number.isFinite(expiry) && now >= expiry) return 'expired'
  return serverStatus
}

/** Remaining time as `mm:ss`, clamped at `00:00`; rounds partial seconds up. */
export function formatPairingCountdown(expiresAt: string, now: number): string {
  const expiry = Date.parse(expiresAt)
  const remainingMs = Number.isFinite(expiry) ? Math.max(0, expiry - now) : 0
  const totalSeconds = Math.ceil(remainingMs / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}
